<template>
  <div class="bigbox">
    <div class="top">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="展示类型：">
          <el-radio-group v-model="radio" @change="change(radio)">
            <el-radio v-model="radio" label="1">销售量</el-radio>
            <el-radio v-model="radio" label="2">销售额</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="销售起止时间：">
          <el-date-picker v-model="formInline.startTime" type="date" style="width: 150px !important"
                          value-format="yyyy-MM-dd" placeholder="开始日期" size="small">
          </el-date-picker>
          -
          <el-date-picker v-model="formInline.endTime" type="date" style="width: 150px !important"
                          value-format="yyyy-MM-dd" placeholder="结束日期" size="small">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="销售年份：">
          <el-select clearable v-model="formInline.years" placeholder="请选择" size="small" style="width: 100px">
            <el-option v-for="item in yearoptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="毕业年份：">
          <el-select clearable v-model="formInline.graduationYear" placeholder="请选择" size="small"
                     style="width: 100px; margin-right: 20px">
            <el-option v-for="item in yearoptions1" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="签单员工：">
          <el-input clearable v-model="formInline.salesman" placeholder="请输入签单员工姓名" size="small"
                    style="width: 170px">
          </el-input>
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" @click="search" size="small" style="margin-left: 20px">搜索</el-button>
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" @click="toExecl" size="small" style="margin-left: 20px">导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table :row-class-name="tableRowClassName" :height="tableHeigth" :data="tableData" border
              :header-cell-style="{ 'text-align': 'center', 'font-size': '14px' }"
              :cell-style="{ 'text-align': 'center', 'font-size': '14px' }" :stripe="true" size="mini">
      <el-table-column label="产品" width="140">
        <el-table-column label="省份" width="140">
          <template slot-scope="scope">
            <el-button type="text" @click="handleclick(scope.row.province)">{{
                scope.row.province
              }}
            </el-button>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column v-for="(item, index) in headerlist" :prop="item" :label="item" :key="index"
                       :render-header="labelHead" sortable>
      </el-table-column>
      <el-table-column label="统计" width="120" prop="totalNum">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {
  statisticsHeader,
  statisticsSalesQuota,
  statisticsSalesToExecl,
  statisticsSalesVolume,
} from "@/api/operationStatistics.js";
import lpyMixin from "@/mixin/lpyMixin";

export default {
  mixins: [lpyMixin],
  data() {
    return {
      headerlist: [],
      yearoptions1: [], //毕业年份
      yearoptions: [], //毕业年份
      radio: "1",
      tableData: [],
      formInline: {
        years: "",
        graduationYear: "",
        size: 500,
      },
    };
  },
  mounted() {
    // this.formInline.graduationYear = new Date().getFullYear();
    this.initYearOptions();
  },
  methods: {
    toExecl() {
      this.formInline.type = this.radio = "1" ? 0 : 1;
      statisticsSalesToExecl(this.formInline).then((res) => {
        const elink = document.createElement("a");
        elink.download = "数据导出.xls"; //定义表格名称，后缀是文件格式
        elink.style.display = "none";
        const blob = new Blob([res], {
          type: "application/vnd.ms-excel",
        });
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        document.body.removeChild(elink);
      });
    },
    search() {
      this.statisticsHeader();
      this.statisticsSalesVolume();
    },
    labelHead(h, {column, index}) {
      let l = column.label.length;
      let f = 22; //每个字大小，其实是每个字的比例值，大概会比字体大小差不多大一点，
      column.minWidth = f * l + 22; //字大小乘个数即长度 ,注意不要加px像素，这里minWidth只是一个比例值，不是真正的长度 //然后将列标题放在一个div块中，注意块的宽度一定要100%，否则表格显示不完全
      return h("span", {class: "table-head", style: {width: "100%"}}, [
        column.label,
      ]);
    },
    handleclick(name) {
      this.$router.push({
        path: "/11.7",
        query: {name: name},
      });
    },
    // 表头
    statisticsHeader() {
      statisticsHeader({}).then((res) => {
        if (res.code == 1) {
          this.headerlist = res.data || [];
        }
      });
    },
    initYearOptions() {
      let date = new Date();
      let year = date.getFullYear();
      let nowtime = date.getTime();
      let date1 = new Date(year + "-08-01");
      let time = date1.getTime();
      if (nowtime >= time) {
        year = year + 1;
      }
      for (let i = 5; i > 0; i--) {
        this.yearoptions1.push({label: year + i, value: year + i});
      }
      for (let i = 0; i < 10; i++) {
        this.yearoptions.push({label: year - i, value: year - i});
        this.yearoptions1.push({label: year - i, value: year - i});
      }
      this.year = year;
      this.formInline.graduationYear = this.year
      this.statisticsHeader();
      this.statisticsSalesVolume();
      // this.formInline = {...this.formInline}
      // this.statisticsExpert();
    },
    change(val) {
      if (val == "1") {
        this.statisticsSalesVolume();
      }
      if (val == "2") {
        this.statisticsSalesQuota();
      }
    },
    // 销量
    statisticsSalesVolume() {
      statisticsSalesVolume(this.formInline).then((res) => {
        if (res.code == 1) {
          let data = res.data || {};
          this.tableData = data.records || [];
        }
      });
    },
    // 销售额
    statisticsSalesQuota() {
      statisticsSalesQuota(this.formInline).then((res) => {
        if (res.code == 1) {
          let data = res.data || {};
          this.tableData = data.records || [];
        }
      });
    },
    tableRowClassName({row, rowIndex}) {
      if (rowIndex == 34) {
        return "success-row";
      }
      return "";
    },
  },
};
</script>

<style scoped lang="less">
.bigbox {
  padding: 20px;

  .top {
    margin-bottom: 10px;
  }
}

/deep/ .el-table .success-row {
  color: #1ab394 !important;
}

/deep/ .el-table thead.is-group th {
  background: none;
  padding: 0px;
}

/deep/ .el-table thead.is-group tr:first-of-type th:first-of-type,
/deep/ .el-table thead.is-group tr:last-of-type th:first-of-type {
  background: #ffffff !important;
}

/deep/ .el-table thead.is-group tr:first-of-type th:first-of-type {
  border-bottom: none;
}

/deep/ .el-table thead.is-group tr:first-of-type th:first-of-type div.cell {
  text-align: right;
}

/deep/ .el-table thead.is-group tr:last-of-type th:first-of-type div.cell {
  text-align: left;
}

/deep/ .el-table thead.is-group tr:first-of-type th:first-of-type:before {
  content: "";
  position: absolute;
  width: 1px;
  height: 100px;
  //   height: 42px;  //自行调整
  top: 0;
  left: 0;
  background-color: grey;
  opacity: 0.2;
  display: block;
  transform: rotate(-71deg);
  //   transform: rotate(-56deg);  //自行调整
  -webkit-transform-origin: top;
  transform-origin: top;
}

/deep/ .el-table thead.is-group tr:last-of-type th:first-of-type:before {
  content: "";
  position: absolute;
  width: 1px;
  height: 100px;
  //   height: 46px;  //自行调整
  bottom: 0;
  right: 0;
  background-color: grey;
  opacity: 0.2;
  display: block;
  transform: rotate(-72deg); //自行调整
  //   transform: rotate(-56deg);
  -webkit-transform-origin: bottom;
  transform-origin: bottom;
}
</style>
